const colors = {
  primary: '#1C3353',
  secondary: '#E86C42',
  sidebarActiveItemColor: '#E86C42'
}

export default colors
